import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EnterpriseCustomOptionsWrapper from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Configuration/components/EnterpriseCustomOptionsWrapper';
import {
  Enterprise,
  EnterpriseBusinessUnit,
  EnterpriseLocation,
  EnterpriseSeniority,
} from 'models/Enterprises';
import { getArrayLength } from 'utils';
import MemberSenioritiesForm from 'components/MemberSenioritiesForm';
import BusinessUnitsForm from 'components/BusinessUnitsForm';
import MemberLocationForm from 'components/MemberLocationForm';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './EnterpriseConfigureWrapper.styles.scss';
import './EnterpriseConfigureWrapper.styles.responsive.scss';

type EnterpriseConfigureWrapperProps = {
  className?: string;
  enterprise: Enterprise;
  updateBusinessUnits: (
    updatedBusinessUnits: EnterpriseBusinessUnit[],
    shouldRefetch?: boolean,
  ) => void;
  updateMemberSeniorities: (
    updatedMemberSeniorities: EnterpriseSeniority[],
    shouldRefetch?: boolean,
  ) => void;
  updateMemberLocations: (
    updatedMemberLocations: EnterpriseLocation[],
    shouldRefetch?: boolean,
  ) => void;
};

const EnterpriseConfigureWrapper: React.FC<EnterpriseConfigureWrapperProps> = (
  props,
) => {
  const {
    className,
    enterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  } = props;

  const { isOfficeManager } = useContext(CurrentUserContext);

  const classes = classNames('enterprise-configure-wrapper', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <EnterpriseCustomOptionsWrapper
        title={t('seniority')}
        description={t('enterpriseSeniorityDescription')}
        count={getArrayLength(enterprise?.memberSeniorities)}
      >
        <MemberSenioritiesForm
          enterpriseId={enterprise?._id}
          memberSeniorities={enterprise?.memberSeniorities}
          disabled={isOfficeManager}
          updateMemberSeniorities={updateMemberSeniorities}
        />
      </EnterpriseCustomOptionsWrapper>

      <EnterpriseCustomOptionsWrapper
        title={t('businessUnits')}
        description={t('businessUnitsDescription')}
        count={getArrayLength(enterprise?.businessUnits)}
      >
        <BusinessUnitsForm
          enterpriseId={enterprise?._id}
          businessUnits={enterprise?.businessUnits}
          disabled={isOfficeManager}
          updateBusinessUnits={updateBusinessUnits}
        />
      </EnterpriseCustomOptionsWrapper>

      <EnterpriseCustomOptionsWrapper
        title={t('locations')}
        description={t('enterpriseLocationDescription')}
        count={getArrayLength(enterprise?.memberLocations)}
      >
        <MemberLocationForm
          enterpriseId={enterprise?._id}
          memberLocations={enterprise?.memberLocations}
          disabled={isOfficeManager}
          updateMemberLocations={updateMemberLocations}
        />
      </EnterpriseCustomOptionsWrapper>
    </div>
  );
};

export default EnterpriseConfigureWrapper;
